<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="germplasm-import-updates.title">Import Germplasm Updates</span>
        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div class="modal-body">
	<div class="row mb-3 clearfix">
		<div class="col-xs-12 col-md-12">
		</div>
	</div>
	<div class="row mb-3">
		<div class="col">
			<span jhiTranslate="template.download.description"></span>&nbsp;
			<a href (click)="export($event)" jhiTranslate="template.download.here" data-test="downloadTemplateLink"></a>.
			<span jhiTranslate="germplasm.import.description.extra"></span>&nbsp;<a target="_blank" [href]="templateHelpLink" jhiTranslate="template.download.here"></a>.
		</div>
	</div>
	<div class="row mb-3 add_top_padding" style="margin-bottom: 35px;">
		<div class="col-2"></div>
		<div class="col-md-8">
			<label class="form-label" for="fileUpload"><i class="fa fa-search"></i><span jhiTranslate="germplasm-manager.file.import.description"></span></label>

			<jhi-file-select id="fileUpload"
				[acceptedFileTypes]="selectedFileType"
				(fileSelected)="onFileChange($event)"
				(fileCleared)="clearSelectedFile()">
			</jhi-file-select>
		</div>
		<div class="col-2">
			<span *ngIf="isProcessing" style="margin-left: 10px;" class="throbber"></span>
		</div>
	</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" [disabled]="isProcessing ? 'disabled' : null" data-bs-dismiss="modal" (click)="close()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="import()" class="btn btn-primary" [disabled]="fileName === '' || isProcessing ? 'disabled' : null"
            data-test="importGermplasmUpdateButton">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.import">Import</span>
    </button>
</div>
